import { render, staticRenderFns } from "./AnalyticsResultChartsPatientStatus.vue?vue&type=template&id=58739f65&scoped=true"
import script from "./AnalyticsResultChartsPatientStatus.vue?vue&type=script&lang=js"
export * from "./AnalyticsResultChartsPatientStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58739f65",
  null
  
)

export default component.exports